import { AdminSchemaListResponse } from "admin/types/interfaces/adminSchema";
import { useFetcher } from "~/hooks/useFetcher";

const { VITE_CATALOG_API } = import.meta.env;

/**
 * Number of schemas requested in a single call. The admin endpoint caps `limit`
 * at 10000; 5000 is a best-effort ceiling to load the full list at once so the
 * schema dropdown can filter client-side. When the total exceeds this, callers
 * should surface `metadata.has_more` rather than silently dropping schemas.
 */
export const ADMIN_SCHEMAS_LIMIT = 5000;

interface UseAdminSchemasOptions {
  /** When false, no request is made (SWR receives a null key). */
  enabled?: boolean;
}

const useAdminSchemas = ({ enabled = true }: UseAdminSchemasOptions = {}) => {
  const url = enabled
    ? `${VITE_CATALOG_API}/admin/schemas?offset=0&limit=${ADMIN_SCHEMAS_LIMIT}`
    : null;

  const { data, error, isLoading } = useFetcher<AdminSchemaListResponse>(url);

  return {
    items: data?.items ?? [],
    metadata: data?.metadata,
    isLoading,
    error,
  };
};

export default useAdminSchemas;
